import { call, put, delay } from "redux-saga/effects";
import { courseAPI } from "@services/api";
import {
  editingCourseActions,
  getDetailsCourseForUpdateActions,
} from "../slices";
import { SECTION_ITEM_TYPE } from "@constants";

function* getDetailsCourseForUpdateWorker({ payload }) {
  // yield delay(300);
  try {
    yield put(getDetailsCourseForUpdateActions.pending());
    yield put(editingCourseActions.resetEditingCourse());
    const response = yield call(courseAPI.getDetailsCourse, payload);
    const course = response.data;

    const { category, audioLanguages, closeCaptions, levels, sections } =
      course;

    const newSections = sections.map((section) => {
      const lectures = section.lectures.map((lecture) => {
        return { ...lecture, type: SECTION_ITEM_TYPE.LECTURE };
      });
      const quizzes = section.quizzes.map((quiz) => {
        return { ...quiz, type: SECTION_ITEM_TYPE.QUIZ };
      });
      const assignments = section.assignments.map((assignment) => {
        return { ...assignment, type: SECTION_ITEM_TYPE.ASSIGNMENT };
      });

      const units = [...lectures, ...quizzes, ...assignments];
      console.log(units);
      // sorting units by index
      units.sort((a, b) => a.index - b.index);
      return {
        ...section,
        units,
      };
    });

    const newCourse = {
      ...course,
      levelIds: levels?.map((level) => level.id) || [],
      categoryId: category.id || [],
      audioLanguageIds:
        audioLanguages?.map((audioLanguage) => audioLanguage.id) || [],
      closeCaptionIds: closeCaptions.id || [],
      sections: newSections,
    };

    yield put(editingCourseActions.updateCourse(newCourse));
    yield put(getDetailsCourseForUpdateActions.success(newCourse));

    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(getDetailsCourseForUpdateActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

export { getDetailsCourseForUpdateWorker };
